import React from 'react'
import ManVsMachineCheckoutLayout from './ManVsMachineCheckoutLayout'
import ManVsMachineCheckoutPage from './ManVsMachineCheckoutPage'

export default function ManVsMachineCheckoutContainer() {
	return (
		<ManVsMachineCheckoutLayout>
			<ManVsMachineCheckoutPage />
		</ManVsMachineCheckoutLayout>
	)
}
